export const headerName = {
    add: "Добавить вид маломерного судна",
    edit: "Редактировать вид маломерного судна",
};
export const kindsBoatsInputs = {
    name: {
        key: "name",
        label: "Наименование вида маломерного судна",
        type: "text",
        required: true,
    }
}
export const getKindsBoatsInputs = ()=>kindsBoatsInputs